/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const Attribute = require('./Attribute');
const AttributeList = require('./AttributeList');
const BooleanAttribute = require('./BooleanAttribute');
const EdgeAttributes = require('./EdgeAttributes');
const FormatAttributes = require('./FormatAttributes');
const ItemAttributes = require('./ItemAttributes');
const LayoutAttributes = require('./LayoutAttributes');
const EventAttributes = require('./EventAttributes');
const NumberAttribute = require('./NumberAttribute');
const ObjectAttribute = require('./ObjectAttribute');
const StringAttribute = require('./StringAttribute');
const TextFormatAttributes = require('./TextFormatAttributes');
const TextNodeAttributes = require('./TextNodeAttributes');
const TreeItemAttributes = require('./TreeItemAttributes');

const Registry = {
	Attribute,
	AttributeList,
	BooleanAttribute,
	EdgeAttributes,
	FormatAttributes,
	ItemAttributes,
	LayoutAttributes,
	EventAttributes,
	NumberAttribute,
	ObjectAttribute,
	StringAttribute,
	TextFormatAttributes,
	TextNodeAttributes,
	TreeItemAttributes,

	// store same under different path...
	'JSG.Attribute': Attribute,
	'JSG.AttributeList': AttributeList,
	'JSG.BooleanAttribute': BooleanAttribute,
	'JSG.EdgeAttributes': EdgeAttributes,
	'JSG.EventAttributes': EventAttributes,
	'JSG.FormatAttributes': FormatAttributes,
	'JSG.ItemAttributes': ItemAttributes,
	'JSG.LayoutAttributes': LayoutAttributes,
	'JSG.NumberAttribute': NumberAttribute,
	'JSG.ObjectAttribute': ObjectAttribute,
	'JSG.StringAttribute': StringAttribute,
	'JSG.TextFormatAttributes': TextFormatAttributes,
	'JSG.TextNodeAttributes': TextNodeAttributes,
	'JSG.TreeItemAttributes': TreeItemAttributes,

	// and to support legacy models...
	'JSG.graph.attr.Attribute': Attribute,
	'JSG.graph.attr.AttributeList': AttributeList,
	'JSG.graph.attr.BooleanAttribute': BooleanAttribute,
	'JSG.graph.attr.EdgeAttributes': EdgeAttributes,
	'JSG.graph.attr.FormatAttributes': FormatAttributes,
	'JSG.graph.attr.ItemAttributes': ItemAttributes,
	'JSG.graph.attr.LayoutAttributes': LayoutAttributes,
	'JSG.graph.attr.NumberAttribute': NumberAttribute,
	'JSG.graph.attr.ObjectAttribute': ObjectAttribute,
	'JSG.graph.attr.StringAttribute': StringAttribute,
	'JSG.graph.attr.TextFormatAttributes': TextFormatAttributes,
	'JSG.graph.attr.TextNodeAttributes': TextNodeAttributes,
	'JSG.graph.attr.TreeItemAttributes': TreeItemAttributes,
};

module.exports = {
	get(name) {
		return Registry[name];
	}
};
